import { ROLE_BY_ID, ROLE_TONE_CLASSES } from '../roleTaxonomy';
import type { UserRoleId } from '../roleTaxonomy';

interface UserRoleChipProps {
  role?: UserRoleId;
  size?: 'sm' | 'md';
}

/** Pill showing a user's Auth0 role. Renders a muted "No role" placeholder
 *  when the role is unknown (the staff-list endpoint doesn't yet surface
 *  Auth0 roles — see userViewModel.ts). */
export default function UserRoleChip({ role, size = 'md' }: UserRoleChipProps) {
  const sm = size === 'sm';
  const base = `inline-flex items-center gap-1.5 rounded-full border font-semibold whitespace-nowrap ${
    sm ? 'h-5 px-2 text-[10.5px]' : 'h-[22px] px-2.5 text-[11.5px]'
  }`;

  const def = role ? ROLE_BY_ID[role] : undefined;
  if (!def) {
    return (
      <span
        className={`${base} text-stone-400 dark:text-stone-500 bg-stone-50 dark:bg-[#1e2520] border-stone-200 dark:border-stone-800`}
      >
        <i className="w-1.5 h-1.5 rounded-full bg-stone-300" />
        No role
      </span>
    );
  }

  return (
    <span className={`${base} ${ROLE_TONE_CLASSES[def.tone]}`}>
      <i className="w-1.5 h-1.5 rounded-full bg-current opacity-80" />
      {def.name}
    </span>
  );
}
